import Component from './instantwin_message_add_edit.vue'
export default Component
